import React from 'react'
import { Box, Flex, Divider } from 'rebass'
import Article from '../elements/Article';
import { colors, fonts, fontSizes, fontWeights } from '../theme'
import styled from 'styled-components'
import Title from '../elements/Text/Title'


const TextSeparator = styled(Divider)`
  width: 30px;
  height: 5px;
  background-color: ${colors.secondary};
  border-bottom: none;
  border-radius: 15px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
`
const Articles = props => (
  <Box width={1} pt={6}style={{ textAlign: 'center' }}>
  <Title color={colors.primary}>Articles</Title>
    <TextSeparator />
  <Flex flexDirection={['column', ,'row']} flexWrap='wrap'>
    {props.data.allMarkdownRemark && props.data.allMarkdownRemark.edges.map(({ node }) => (
      <Box key={node.id} width={[1,1,1/2,1/3]}><Article  article={node} /></Box>
    ))}
  </Flex>
  </Box>
)

export default Articles;

export const query = graphql`
  query ArticleQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___dateTime], order: DESC } filter: { id: { regex: "/article/" } }) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          id
          frontmatter {
            title
            tagline
            author
            category
            dateTime(formatString: "DD/MM/YYYY")
            cover {
              childImageSharp {
                sizes(maxWidth: 1600, quality: 100, traceSVG: { color: "#f3f3f3" }) {
                  ...GatsbyImageSharpSizes_tracedSVG
                }
              }
            }
          }
          excerpt
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/articles.js